import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import {
  FINANCIAL_PRODUCT_C,
  FORM_AUTO,
  FORM_BP,
  FORM_CONSUMO,
  FORM_MG,
  FORM_MG_NO_SHOP,
  LANGUAGE_CATALAN,
  LANGUAGE_SPANISH,
  OPERATIVE_EIC,
  OPERATIVE_ESC,
  PENDIENTES_DE_DATOS,
  POINT_OF_SALE,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_NEW,
  REQUEST_MODE_VIEW,
  TYPE_BALANCE_N,
  TYPE_BALANCE_S,
  TYPE_BALANCE_T,
} from '@app/@core/constants/requests.constants';
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import { CredentialsService } from '@app/login';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { CommonDataDTO, VendorComboDTO } from '@app/requests/model/combos-model';
import { Credentials } from '@app/@core/models/login-models';
import { UserType } from '@app/@core/constants/user-credentials.constants';
import { MAX_SELECTOR_DATA } from '@app/@core/constants/material-custom.constants';
import { RequestFinanceService } from '../request-finance/request-finance.service';
import {
  DigitalIdDTO,
  DigitalIdResponseDTO,
  RequestBalanceDTO,
  StatesFieldsFrontDTO,
} from '@app/requests/model/requests-model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DatepickerUtilsService } from '@app/@shared/services/utils/datepicker-utils.service';
import { LOCALE_ES } from '@app/@core/constants/common.constants';
import { RequestsGetDataApi } from '@app/requests/requests-get-data-service/requests-get-data-api.service';

@UntilDestroy()
@Component({
  selector: 'scf-point-of-sale',
  templateUrl: './point-of-sale.component.html',
  styleUrls: ['./point-of-sale.component.scss'],
})
export class PointOfSaleComponent implements OnInit {
  @Input() public isMG: boolean;
  @Input() public isMgWithShopping: boolean;
  @Input() public isBP: boolean;
  @Input() public mode: string = REQUEST_MODE_NEW;
  @Input() public request: any = null;
  @Input() state: CommonDataDTO;
  @Input() public operative: { value: string }; //no hace falta hacerlo de la otra forma, porque al final se añaden al mismo formulario
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Output() public saveButtonCheck = new EventEmitter<any>();
  //para pasarle el establecimiento al componente datos de la solicitud
  @Output() establishment = new EventEmitter<CommonDataDTO>();
  @Output() vendor = new EventEmitter<VendorComboDTO>();
  @Output() isFinishedLoading = new EventEmitter<any>();
  @Output() typeBalance = new EventEmitter<RequestBalanceDTO>();

  private isEstablishmentLoading: boolean = true;
  private isVendorLoading: boolean = true;
  private isBalanceICLoading: boolean = true;
  private isCalculator: boolean = false;
  private firstloadEdit: boolean = true;

  public pointOfSaleDataForm: FormGroup;

  establishmentData: CommonDataDTO[];
  vendorData: VendorComboDTO[];
  languages: CommonDataDTO[];
  inputChannels: CommonDataDTO[];
  employeeMGData: any[];

  userInfo: Credentials;
  currentDate: Date = new Date();
  maxRequestDate: Date = new Date('12/31/2099');
  valueVendorFromCalculator: string = null;

  //PE_725 Fenix
  fieldsDisabled: StatesFieldsFrontDTO[];

  constructor(
    private formBuilder: FormBuilder,
    private requestStore: RequestsSaveSendStore,
    private combosStore: CombosStore,
    private translateService: TranslateService,
    private credentials: CredentialsService,
    private requestFinanceService: RequestFinanceService,
    private customValidators: CustomValidatorsService,
    private datepickerUtils: DatepickerUtilsService,
    private requestsGetDataApi: RequestsGetDataApi
  ) {
    this.establishmentData = null;
    this.vendorData = null;

    this.userInfo = this.credentials.credentials;
    console.log('userinfo ', this.userInfo);

    this.translateService.currentLang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan();
  }

  ngOnInit(): void {
    this.pointOfSaleDataForm = this.formBuilder.group(
      {
        establishment: ['', [Validators.required]],
        requestDate: [{ value: this.currentDate, disabled: true }, Validators.required],
        vendor: ['', Validators.required],
        requestLanguage: ['', Validators.required],
      },
      { updateOn: 'change' }
    );

    // cargamos los combos desde front
    this.languages = JSON.parse(JSON.stringify(this.combosStore.languages));
    this.languages.forEach((item) => {
      item.value = this.translateService.instant(item.value);
    });

    this.translateService.onLangChange.pipe(untilDestroyed(this)).subscribe(() => {
      this.languages = JSON.parse(JSON.stringify(this.combosStore.languages));
      this.languages.forEach((item) => {
        item.value = this.translateService.instant(item.value);
      });
    });

    this.pointOfSaleDataForm?.controls.requestLanguage?.setValue(!this.isBP ? LANGUAGE_SPANISH : LANGUAGE_CATALAN);

    if (this.isMG) {
      this.pointOfSaleDataForm.addControl(
        'employeeInternalRefMG',
        new FormControl('', this.customValidators.isMangoEmployeeCodeValid)
      );
      this.pointOfSaleDataForm.addControl('idStoreMG', new FormControl({ value: '', disabled: true }));
      this.pointOfSaleDataForm.addControl('inputChannel', new FormControl('', Validators.required));
      this.pointOfSaleDataForm.addControl('employeeMG', new FormControl('', Validators.required));

      this.employeeMGData = this.combosStore.employeeMGData;
      this.pointOfSaleDataForm.controls.employeeMG.setValue(this.employeeMGData[1].value);

      this.inputChannels = this.combosStore.inputChannelsMG;
      if (this.inputChannels.length === 1) {
        this.pointOfSaleDataForm.controls.inputChannel.setValue(this.inputChannels[0].id);
      }
    } else if (this.isBP) {
      this.pointOfSaleDataForm.addControl('inputChannel', new FormControl('', Validators.required));

      this.inputChannels = this.combosStore.inputChannels;
      if (this.inputChannels.length === 1) {
        this.pointOfSaleDataForm.controls.inputChannel.setValue(this.inputChannels[0].id);
      }
    } else if (this.isMgWithShopping) {
      this.pointOfSaleDataForm.addControl(
        'employeeInternalRefMG',
        new FormControl('', this.customValidators.isMangoEmployeeCodeValid)
      );
      this.pointOfSaleDataForm.addControl('idStoreMG', new FormControl({ value: '', disabled: true }));
    }

    if (
      this.credentials.credentials.userType === UserType.ADMIN ||
      this.credentials.credentials.userType === UserType.OFFICE_DIRECTOR ||
      this.mode === REQUEST_MODE_VIEW
    ) {
      //for admin only load stablishment and vendor of the request
      this.combosStore
        .getUserById(this.request.establishment)
        .then(
          (data) => {
            this.establishmentData = [];
            this.establishmentData.push(data);
            this.isEstablishmentLoading = false;
          },
          (error) => {
            this.isEstablishmentLoading = false;
            console.error(error);
          }
        )
        .finally(() => {
          this.isEstablishmentLoading = false;
          this.changeLoadingState();
        });

      //load vendor
      this.combosStore
        .getUserById(this.request.vendor)
        .then(
          (data) => {
            this.vendorData = [];
            this.vendorData.push(data);
            this.pointOfSaleDataForm.controls.vendor.setValue(data.id);
            this.isVendorLoading = false;
            this.changeLoadingState();
          },
          (error) => {
            this.isVendorLoading = false;
            console.error(error);
          }
        )
        .finally(() => {
          this.isVendorLoading = false;
          this.changeLoadingState();
        });
    } else {
      this.combosStore
        .getEstablishments()
        .then(
          (data) => {
            this.establishmentData = data;
            //seteado de combos si solo tienen un valor
            if (this.establishmentData.length === 1) {
              this.pointOfSaleDataForm.controls.establishment.setValue(this.establishmentData[0].id);
              this.establishment.emit(this.pointOfSaleDataForm.controls.establishment.value);
            } else {
              this.isVendorLoading = false;
            }
          },
          (error) => {
            this.isVendorLoading = false;
            console.error(error);
          }
        )
        .finally(() => {
          this.isEstablishmentLoading = false;
          this.changeLoadingState();
        });
    }

    this.pointOfSaleDataForm.controls.establishment.valueChanges.subscribe((value) => {
      if (
        this.credentials.credentials.userType != UserType.ADMIN &&
        this.credentials.credentials.userType != UserType.OFFICE_DIRECTOR
      ) {
        if (value) {
          this.getVendors(value);
          this.establishment.emit(value);
          this.vendor.emit(null);
          if (this.userInfo.division.toString() === FINANCIAL_PRODUCT_C && this.mode != REQUEST_MODE_VIEW) {
            this.getBalanceIC(value, this.userInfo.division.toString());
          }
        }
      }
    });

    if (this.requestStore.getMarcaFormulario() === FORM_BP) {
      this.requestStore.setFormularioBonpreu(this.pointOfSaleDataForm, POINT_OF_SALE);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG_NO_SHOP) {
      this.requestStore.setFormularioMangoNoShopping(this.pointOfSaleDataForm, POINT_OF_SALE);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG) {
      this.requestStore.setFormularioMg(this.pointOfSaleDataForm, POINT_OF_SALE);
    } else if (
      this.requestStore.getMarcaFormulario() === FORM_AUTO ||
      this.requestStore.getMarcaFormulario() === FORM_CONSUMO
    ) {
      this.requestStore.isCalculatorData$.subscribe((data) => {
        this.isCalculator = data;
      });
      if (this.requestStore.getMarcaFormulario() === FORM_AUTO) {
        this.isCalculator
          ? this.updateCombos(this.requestStore.listaFormulariosAutos[POINT_OF_SALE])
          : this.requestStore.setFormularioAutos(this.pointOfSaleDataForm, POINT_OF_SALE);
      } else {
        this.isCalculator
          ? this.updateCombos(this.requestStore.listaFormulariosConsumo[POINT_OF_SALE])
          : this.requestStore.setFormularioConsumo(this.pointOfSaleDataForm, POINT_OF_SALE);
      }
    }

    this.pointOfSaleDataForm.statusChanges.subscribe(() => {
      if (this.pointOfSaleDataForm) {
        this.changeContinueStatus.emit({ form: <FormGroup>this.pointOfSaleDataForm, id: POINT_OF_SALE });
        this.saveButtonCheck.emit({ form: <FormGroup>this.pointOfSaleDataForm, id: POINT_OF_SALE });
      }
    });

    if (this.mode === REQUEST_MODE_VIEW) {
      if (
        this.state.id !== PENDIENTES_DE_DATOS ||
        (this.state.id === PENDIENTES_DE_DATOS && this.operative?.value === 'EIC')
      ) {
        this.pointOfSaleDataForm.disable();
      }
      this.setValuesToForm();
    } else if (this.mode === REQUEST_MODE_EDIT) {
      this.setValuesToForm();
    }
  }

  private getVendors(establishment: string) {
    if (!this.isVendorLoading) {
      this.isVendorLoading = true;
      this.changeLoadingState();
    }
    this.vendorData = [];
    this.pointOfSaleDataForm.controls.vendor.reset();

    this.combosStore
      .loadVendors(establishment)
      .then(
        (vendors) => {
          this.vendorData = vendors;
          if (this.vendorData.length === 1) {
            this.pointOfSaleDataForm.controls.vendor.setValue(
              this.mode === REQUEST_MODE_NEW ? this.vendorData[0] : this.vendorData[0].id
            );
            this.onChangeVendor();
          }
          //set the vendor when editing
          if (this.mode !== REQUEST_MODE_NEW && this.firstloadEdit) {
            this.pointOfSaleDataForm.controls.vendor.setValue(this.request.vendor);
            this.vendor.emit(this.vendorData.filter((v) => v.id === this.request.vendor)[0]);
            this.firstloadEdit = false;
          }
          //set vendor from calculator
          if (this.valueVendorFromCalculator)
            this.pointOfSaleDataForm.controls.vendor.setValue(this.valueVendorFromCalculator);
        },
        (error) => {
          this.vendorData = [];
          this.pointOfSaleDataForm.controls.vendor.setValue(null);
          console.error(error);
        }
      )
      .finally(() => {
        this.isVendorLoading = false;
        this.changeLoadingState();
      });
  }

  changeLanguage(value: any) {
    console.log(value);
    if (value === LANGUAGE_SPANISH) {
      this.translateService.use(LOCALE_ES);
      this.combosStore.setLanguageRequest(LANGUAGE_SPANISH);
    } else {
      this.translateService.use('es-CAT');
      this.combosStore.setLanguageRequest(LANGUAGE_CATALAN);
    }
  }

  updateCombos(form: FormGroup) {
    if (form !== undefined) {
      Object.keys(this.pointOfSaleDataForm.controls).forEach((key) => {
        if (form.controls[key] !== null) {
          this.pointOfSaleDataForm.controls[key].setValue(form.controls[key].value);
          if (key == 'vendor') {
            this.valueVendorFromCalculator = form.controls[key].value;
            this.vendor.emit(this.pointOfSaleDataForm.controls.vendor.value);
          }
        }
      });
    }
  }

  onChangeVendor() {
    let valueVendor: any = null;
    if (this.mode === REQUEST_MODE_NEW) {
      valueVendor = this.pointOfSaleDataForm.controls.vendor.value?.id;
    } else {
      valueVendor = this.pointOfSaleDataForm.controls.vendor.value;
    }
    this.vendor.emit(this.vendorData.filter((v) => v.id === valueVendor)[0]);
  }

  setValuesToForm() {
    this.pointOfSaleDataForm.controls.establishment.setValue(this.request.establishment);
    //mando el establecimiento para poder hacer llamadas
    this.establishment.emit(this.request.establishment);

    let requestDateFormated = this.request.dateRequest?.split('/');

    this.pointOfSaleDataForm.controls.requestDate.setValue(
      new Date(requestDateFormated[2], requestDateFormated[1] - 1, requestDateFormated[0])
    );

    //request language
    this.pointOfSaleDataForm.controls.requestLanguage.setValue(
      this.request.language === '' || this.request.language === null ? LANGUAGE_SPANISH : this.request.language
    );

    //EN LA ANTIGUA WEB TAMPOCO SE MUESTRAN
    // this.pointOfSaleDataForm.controls.establishment.setValue(this.request.establishment);
    // this.pointOfSaleDataForm.controls.vendor.setValue(this.request.vendor); //the vendor is set when the stablishment is changed

    if (this.isMG) {
      this.pointOfSaleDataForm.controls.idStoreMG.setValue(this.request.idStore);
      this.pointOfSaleDataForm.controls.employeeInternalRefMG.setValue(this.request.employeeCode);
      this.pointOfSaleDataForm.controls.inputChannel.setValue(this.request.captacionCanal);
      this.pointOfSaleDataForm.controls.employeeMG.setValue(this.request.employeeMG === 'T' ? true : false); //viene T/F de host
    } else if (this.isMgWithShopping) {
      this.pointOfSaleDataForm.controls.employeeInternalRefMG.setValue(this.request.employeeCode);
      this.pointOfSaleDataForm.controls.idStoreMG.setValue(this.request.idStore);
    } else if (this.isBP) {
      this.pointOfSaleDataForm.controls.inputChannel.setValue(this.request.captacionCanal);
    }

    this.pointOfSaleDataForm.markAllAsTouched();
  }

  changeLoadingState() {
    if (!this.isEstablishmentLoading && !this.isVendorLoading) {
      this.isFinishedLoading.emit({ formID: POINT_OF_SALE, value: true });
    } else {
      this.isFinishedLoading.emit({ formID: POINT_OF_SALE, value: false });
    }
  }

  isGenericSelect() {
    return this.establishmentData?.length < MAX_SELECTOR_DATA;
  }

  private getBalanceIC(establishment: string, financialProduct: string) {
    if (!this.isBalanceICLoading) {
      this.isBalanceICLoading = true;
      this.changeLoadingState();
    }

    let requestBalanceIC: RequestBalanceDTO = {
      establishment: establishment,
      financialProduct: financialProduct,
      balance: '',
      financial: '',
    };

    this.requestFinanceService
      .requestBalanceIC(requestBalanceIC)
      .subscribe(
        (data: RequestBalanceDTO) => {
          if (this.mode === REQUEST_MODE_EDIT) {
            if (data.balance === TYPE_BALANCE_S && this.operative?.value === OPERATIVE_ESC) {
              data.balance = TYPE_BALANCE_N;
            } else if (data.balance === TYPE_BALANCE_S && this.operative?.value === OPERATIVE_EIC) {
              data.balance = TYPE_BALANCE_T;
            }
          }

          console.log(data);
          this.typeBalance.emit(data);
          this.establishment.emit(this.pointOfSaleDataForm.controls.establishment.value);
          this.isBalanceICLoading = false;
          this.changeLoadingState();
        },
        (error) => {
          this.typeBalance.emit(requestBalanceIC);
          console.error(error);
          this.isBalanceICLoading = false;
          this.changeLoadingState();
        }
      )
      .add(() => {
        this.isBalanceICLoading = false;
        this.changeLoadingState();
      });
  }

  ngAfterViewInit() {
    //PE_725 Fenix
    if (this.mode === REQUEST_MODE_EDIT && this.request !== null && this.request.fieldsDisable !== null) {
      this.fieldsDisabled = this.request.fieldsDisable;
      this.disableFieldsByCore();
    }
  }

  private disableFieldsByCore() {
    if (this.fieldsDisabled !== null && this.fieldsDisabled !== undefined) {
      const form = this.pointOfSaleDataForm;
      this.fieldsDisabled.forEach((field) => {
        const toDisable = form.get(field.campoName);
        if (toDisable !== null && toDisable !== undefined) {
          toDisable.disable();
        }
      });
    }
  }
}
